export default __webpack_public_path__ + "static/media/17.0d831747.jpg";